import React, { createContext, useState, useContext } from 'react';
import { colors } from '../styles/theme';

const BackgroundContext = createContext();

export const THEMES = {
  default: {
    background: '#050505',
    orb1: colors.primary,
    orb2: colors.secondary,
    orb3: '#3b82f6'
  },
  babymee: {
    background: '#1e0b24', // Deep Pinkish Purple (Görseldeki butonun koyu versiyonu)
    orb1: '#e879f9', // Fuchsia 400
    orb2: '#c084fc', // Purple 400
    orb3: '#60a5fa' // Blue 400 (Logo sonundaki mavi)
  },
  spaceSpan: {
    background: '#020617', // Slate 950 (Deep Space)
    orb1: '#1e3c72', // Deep Blue
    orb2: '#2a5298', // Lighter Blue
    orb3: '#60a5fa' // Blue 400
  },
  paylasCozulsun: {
    background: '#2e1065', // Violet Dark
    orb1: '#a855f7', // Purple 500
    orb2: '#d946ef', // Fuchsia 500
    orb3: '#7c3aed' // Violet 600
  },
  carsidanAl: {
    background: '#0b1120', // Dark Navy Blue (Tailwind slate-900 benzeri)
    orb1: '#38bdf8', // Sky 400
    orb2: '#818cf8', // Indigo 400
    orb3: '#2dd4bf' // Teal 400
  }
};

export const BackgroundProvider = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState(THEMES.default);

  const setTheme = (themeKey) => {
    if (THEMES[themeKey]) {
      setCurrentTheme(THEMES[themeKey]);
    } else {
      setCurrentTheme(THEMES.default);
    }
  };

  return (
    <BackgroundContext.Provider value={{ currentTheme, setTheme }}>
      {children}
    </BackgroundContext.Provider>
  );
};

export const useBackground = () => useContext(BackgroundContext);
